import React, { useState } from "react";
import { IconButton, Menu, MenuItem, useMediaQuery } from "@material-ui/core";
import { EllipsisVertical, TriangleAlert } from "lucide-react";
import { useCreatorPostStyles } from "../../Main/Sidebar/MyFeed-explore/style";
import ReportPostDialog from "../ReportPostDialog";
import { useAppSelector } from "../../../redux/typedHooks";
import { UserInterface } from "../../../types/user";
import { ReactComponent as PencilIcon } from "../../../assets/images/icons/pencilIcon.svg";
import theme from "../../../theme";

interface CommentMenuButtonProps {
    comment: any;
    handleEdit: () => void,
    isOpenMenuMobile: boolean,
    setOpenMenuMobile: (isOpen: boolean) => void,
}

export default function EllipsisMenuButton({
    comment,
    handleEdit,
    isOpenMenuMobile,
    setOpenMenuMobile
}: CommentMenuButtonProps) {
    const classes = useCreatorPostStyles();
    const [menuPos, setMenuPos] = useState<{ top: number; left: number } | null>(
        null
    );

    const [reportDialogOpen, setReportDialogOpen] = useState(false);
    const [reportCommentId, setReportCommentId] = useState<string | null>(null);

    const currentUser = useAppSelector<UserInterface | null>(
        state => state.user.currentUser
    );
    const meId = currentUser?.id;

    const isMobileDevice = useMediaQuery(theme.breakpoints.down("sm"))

    const openMenu = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();

        const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();

        setMenuPos({
            top: rect.bottom,
            left: rect.right,
        });
    };

    const closeMenu = () => {
        setMenuPos(null);
        setOpenMenuMobile(false)
    };

    const handleReport = (comment: any) => {
        if (!comment) return
        setReportCommentId(comment.id);
        setReportDialogOpen(true);
    }

    return (
        <>
            {!isMobileDevice &&
                <IconButton onClick={openMenu}>
                    <EllipsisVertical
                        color="#747474"
                        fill="#747474"
                        size={24}
                        style={{ strokeWidth: 1 }}
                    />
                </IconButton>
            }

            <Menu
                open={Boolean(menuPos) || isOpenMenuMobile}
                onClose={closeMenu}
                anchorReference="anchorPosition"
                anchorPosition={menuPos ?
                    { top: menuPos.top, left: menuPos.left - 40 } :
                    { top: window.innerHeight / 2, left: window.innerWidth / 2, }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                PaperProps={{ style: { position: "fixed" } }}
                disablePortal={false}
                className={classes.menu}
            >
                {meId !== comment.user.id ?
                    <MenuItem
                        className={classes.menuItemReport}
                        onClick={() => {
                            closeMenu();
                            handleReport(comment);
                        }}
                    >
                        <TriangleAlert size={24} color="#FD3C84" />
                        Report comment
                    </MenuItem> :
                    <div>
                        <MenuItem
                            className={classes.menuItemTip}
                            onClick={() => {
                                closeMenu();
                                handleEdit();
                            }}
                            style={{ marginLeft: "8px" }}
                        >
                            <PencilIcon
                                width={24}
                                height={24}
                            />
                            Edit comment
                        </MenuItem>
                    </div>
                }
            </Menu >
            <ReportPostDialog
                open={reportDialogOpen && !!reportCommentId}
                onClose={() => {
                    setReportDialogOpen(false);
                    setReportCommentId(null);
                }}
                typeReport="comment"
                targetId={reportCommentId || ""}
            />
        </>
    );
}